import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  duplicateTitle,
  resumeEditActions,
} from "../../Store/Actions/ResumeActions";
import { coverEditActions } from "../../Store/Actions/CoverLetterActions";
import {
  RESUME_DUPLICATE_TITLE_RESET,
  RESUME_UPDATE_RESET,
} from "../../Store/Constants/ResumeConstants";
import { COVER_UPDATE_RESET } from "../../Store/Constants/CoverLetterConstants";
import {
  getAllResumes,
  getResumeById,
} from "../../Store/Actions/ResumeActions";
import { getAllCoverLetters } from "../../Store/Actions/CoverLetterActions";
function Renameresume(props) {
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [errors, setErrors] = useState("");
  const dispatch = useDispatch();
  const duplicate_title = useSelector((state) => state.duplicateTitle.data);
  const nameUpdate = useSelector((state) => state.resumeUpdate.data);
  const nameCoverUpdate = useSelector((state) => state.coverUpdate.data);
  const [buttonView, setButtonView] = useState(false);
  const [rand, setRand] = useState("");

  useEffect(() => {
    if (props && props.name) {
      setName(props.name);
      setId(props.resumeId);
    }
  }, [props]);

  const changeName = () => {
    if (props && props.cover == "cover") {
      dispatch(coverEditActions(id, { title: name }));
    } else {
      dispatch(resumeEditActions(id, { title: name }));
    }
  };

  useEffect(() => {
    if (nameCoverUpdate && nameCoverUpdate.title) {
      props.hideResume();
      dispatch({ type: COVER_UPDATE_RESET });
      dispatch(getAllCoverLetters("initial"));
    }
  }, [nameCoverUpdate]);

  const handleChange = (e) => {
    if (props.name != e.target.value && e.target.value != "") {
      setButtonView(true);
    } else {
      setButtonView(false);
    }
    setName(e.target.value);
  };

  //   useEffect(() => {
  //     dispatch(getResumeById(props.resumeId));
  //   }, [props.resumeId]);

  useEffect(() => {
    if (nameUpdate && nameUpdate.success) {
      props.hideResume();
      dispatch({ type: RESUME_UPDATE_RESET });
      dispatch(getAllResumes("initial"));
    }
  }, [nameUpdate]);

  return (
    <>
      <Modal
        show={props.renameResume}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onEscapeKeyDown={props.hideResume}
        onHide={props.hideResume}
      >
        <Modal.Body>
          <img
            onClick={props.hideResume}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle">
                {props && props.cover == "cover"
                  ? "Rename Cover Letter"
                  : "Rename Resume"}
              </h4>
              <div className="duplicatebody">
                <p className="ml-2" style={{ textAlign: "left" }}>
                  Change Name{" "}
                </p>
                <input
                  type="text"
                  name="title"
                  value={name}
                  className="form-control customform duplicateinput"
                  onChange={handleChange}
                />
                {errors && errors != "" && (
                  <p
                    className="error"
                    style={{
                      textAlign: "left",
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {errors}
                  </p>
                )}
              </div>
            </div>
            {buttonView ? (
              <div className="row mt-4">
                <div className="col-md-6">
                  <button
                    onClick={props.hideResume}
                    style={{ boxShadow: "none" }}
                    className="btn primarybtn float-right w-75 mainborder"
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-75"
                    onClick={changeName}
                  >
                    Change Name
                  </button>
                </div>
              </div>
            ) : (
              <div className="row mt-4 ">
                <div className="col-md-6  ">
                  <button
                    onClick={props.hideResume}
                    className="btn primarybtn float-right w-75 mainborder"
                    style={{ boxShadow: "none" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Renameresume;
